import { render, staticRenderFns } from "./TechNewsItem.vue?vue&type=template&id=1afeaa22&scoped=true&"
import script from "./TechNewsItem.vue?vue&type=script&lang=js&"
export * from "./TechNewsItem.vue?vue&type=script&lang=js&"
import style0 from "./TechNewsItem.vue?vue&type=style&index=0&id=1afeaa22&scoped=true&lang=css&"
import style1 from "./TechNewsItem.vue?vue&type=style&index=1&id=1afeaa22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afeaa22",
  null
  
)

export default component.exports